// Unpublished Work © 2025 Deere & Company

import t from 'tcomb';

export const SelectedContext = t.struct({
    selectedOrganization: t.maybe(t.String),
    selectedDBS: t.maybe(t.String)
}, {
    name: 'SelectedContext',
    defaultProps: {
        selectedOrganization: null,
        selectedDBS: null
    }
});
